import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { useRouter } from "next/router";
import { Button } from "./ui/button";
import { Lock } from "@phosphor-icons/react";
import { useAtom } from "jotai";
import { purchasePopup } from "@/Atoms";

function ModalCustomWishlistLimit({ isModalOpen, setIsModalOpen }) {
  const router = useRouter();
  const currentPath = router.asPath;
  const [openPurchasePopup, setOpenPurchasePopup] = useAtom(purchasePopup);

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <>
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog as='div' className='relative z-10' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black/25' />
          </Transition.Child>
          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  <div className='text-center'>
                    <Lock className='mx-auto mt-0 mb-2 text-3xl text-orange-500' />
                    <p className='mt-0 mb-2 text-2xl font-bold text-slate-800'>
                      You are on a free subscription.
                    </p>
                    <p className='my-0 text-sm text-slate-800/50'>
                      Creating a customized watch list requires you to be a paid subscriber. Upgrade to a paid subscription to enable this feature.
                    </p>
                    <div className='mt-4 flex items-center justify-center gap-3 mt-5 mb-0'>
                    <Button
                        className='w-full h-auto py-3 lg:py-3.5 mt-5 lg:mt-8 bg-gradient-to-b from-background/20 hover:bg-background/20 border-white/20 text-slate-700 to-background/10'
                        onClick={closeModal}
                        style={{ marginLeft: "10px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className='w-full h-auto py-3 lg:py-3.5 mt-5 lg:mt-8 bg-gradient-to-b from-background/80 border-y hover:bg-background/80 border-white/20 text-white to-background'
                        onClick={() => {
                          closeModal();
                          router.push(`/pricing`);
                        }}
                      >
                        Upgrade Plan
                      </Button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default ModalCustomWishlistLimit;
